import { useEffect, useState } from 'react';
import { miniappApi } from '@/api/miniapp/miniappApi';
import type { LessonDto } from '@/api/miniapp/types';

/**
 * Текст задания для экрана диалога.
 *
 * Нужен прямо в чате: без него в пустом диалоге непонятно, о чём говорить с
 * ассистентом. У варианта задания своё условие — показывать вместо него общий
 * текст урока неверно.
 */
export function useAssignmentTask(assignmentId: string, variantId?: string): LessonDto | null {
  const [lesson, setLesson] = useState<LessonDto | null>(null);

  useEffect(() => {
    if (!assignmentId) return undefined;
    let cancelled = false;

    void miniappApi
      .getLesson(assignmentId)
      .then((data) => {
        if (cancelled) return;
        const variant = data.variants?.find((item) => String(item.variant_id) === variantId);
        setLesson(
          variant ? { ...data, title: variant.title, description: variant.description } : data
        );
      })
      // Задание — подсказка к диалогу, а не его условие: без текста чат
      // работает, и подменять его экраном ошибки не за что
      .catch(() => undefined);

    return () => {
      cancelled = true;
    };
  }, [assignmentId, variantId]);

  return lesson;
}
